import styled from '@emotion/styled';
import rem from '../../utils/rem/rem';
import { StyledLabel } from '../Input/Input.styles';
import { RadioGroupLayouts } from './RadioGroup.types';

interface StyledProps {
  layout: RadioGroupLayouts;
  errorText?: string;
}

export const RadioGroupLabel = styled(StyledLabel)`
  margin: 0 ${rem(8)} 0 0;
`;

export const OptionsContainer = styled.ul<StyledProps>`
  display: flex;
  flex-direction: ${({ layout }) => layout};
  gap: ${({ layout }) => (layout === RadioGroupLayouts.Row ? rem(16) : rem(8))};
  padding: 0;
  margin: 0;
  margin-bottom: ${({ errorText }) => (errorText ? rem(4) : '')};
`;
